import BasicModal from 'components/Modal'
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import SoftTypography from 'components/SoftTypography'
import React from 'react'
import { useSelector } from 'react-redux'

const TermModal = ({ show, unShow, offerId, handleActivateOffer,fetchData }) => {

  const userTheme = useSelector((state) => state.commonSlice.theme);

  return (
    <BasicModal show={show} unShow={unShow} isremoveCrossIcon={false}>

      <SoftBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={2}>

        <SoftTypography variant="h6" fontWeight="bold" color="text">
          By clicking on the "Accept" button, you agree to our <a href="https://1onus.com/merchant-terms-and-conditions" target='_blank' 
          style={{ fontWeight: 800, color: userTheme=='dark'?"white":"black" , textDecoration:"underline"}}  >
          <u>Terms and Conditions</u></a>.
        </SoftTypography>

      </SoftBox>
      <SoftBox 
      p={2}
      sx={{ Width: "100%" }}  
          display="flex"
          justifyContent="space-between"
          gap={2}
        >
          <SoftButton fullWidth variant="outlined" color="info" onClick={() =>{ unShow(false); fetchData()}}>
            Cancel
          </SoftButton>
          <SoftButton fullWidth
            variant="gradient"
            color="info" onClick={() => handleActivateOffer(offerId)}>
            Accept
          </SoftButton>
        </SoftBox>
    </BasicModal>
  )
}

export default TermModal